export default function Solutions() {
  const solutions = [
    {
      icon: 'ri-award-line',
      title: '最新技術と豊富な実績で理想の笑顔を実現',
      description: '累計3,200名以上の治療実績を持つ当院。最先端のデジタル技術と独自の治療メソッドで、あなたの理想の歯並びを最短ルートで実現します。',
      color: 'from-teal-500 to-cyan-500',
      image: 'https://public.readdy.ai/ai/img_res/7dfc5820031358bf25d232cfe798be2d.jpg'
    },
    {
      icon: 'ri-heart-line',
      title: '一人ひとりに寄り添う丁寧なサポート',
      description: '治療中の不安や疑問に24時間LINE相談で対応。定期的なチェックで進捗を確認し、安心して治療を続けられます。',
      color: 'from-pink-500 to-rose-500',
      image: 'https://readdy.ai/api/search-image?query=A%20caring%20Japanese%20female%20dentist%20having%20a%20warm%20consultation%20with%20a%20female%20patient%20in%20her%2030s%20in%20a%20modern%20dental%20clinic%2C%20soft%20professional%20lighting%2C%20comfortable%20consultation%20room%20with%20plants%20and%20modern%20decor%2C%20showing%20trust%20and%20care%2C%20professional%20medical%20photography&width=700&height=500&seq=solution-2&orientation=landscape'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '明確な料金体系と柔軟な支払いプラン',
      description: '追加費用なしの安心価格。月々9,800円からの分割払いも可能。無料カウンセリングで詳しくご説明します。',
      color: 'from-purple-500 to-indigo-500',
      image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20woman%20in%20her%2030s%20looking%20relieved%20and%20happy%20while%20reviewing%20clear%20pricing%20documents%20with%20a%20dental%20staff%20member%2C%20bright%20natural%20lighting%2C%20modern%20clean%20clinic%20reception%20area%2C%20professional%20consultation%20photography%20showing%20transparency%20and%20trust&width=700&height=500&seq=solution-3&orientation=landscape'
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            当院が<br />
            <span className="text-teal-600">選ばれる3つの理由</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            安心して治療を受けていただくために
          </p>
        </div>

        <div className="space-y-16">
          {solutions.map((solution, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 items-center`}>
              <div className="lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <img 
                    src={solution.image} 
                    alt={solution.title} 
                    className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-br ${solution.color} opacity-10`}></div>
                </div>
              </div>
              
              <div className="lg:w-1/2 space-y-6">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br ${solution.color} shadow-lg`}>
                  <i className={`${solution.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="flex items-start gap-4">
                  <span className={`text-6xl font-bold bg-gradient-to-br ${solution.color} bg-clip-text text-transparent flex-shrink-0`}>
                    0{index + 1}
                  </span>
                  <h3 className="text-3xl font-bold text-gray-900 leading-tight pt-2">{solution.title}</h3>
                </div>
                
                <p className="text-lg text-gray-600 leading-relaxed">
                  {solution.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}